"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Reference: gs1ca.org/cannabis-consumer/GS1-Barcoding-Guidelines-Consumer-Inner-Level-Cannabis-Products.pdf
// Sample batch barcode: 01195011015300001714070410AB-123
function isBatchBarcode(barcode) {
    var separatorCandidate = "" + barcode[16] + barcode[17];
    var isSeparator = separatorCandidate === '17' || separatorCandidate === '15' || separatorCandidate === '13';
    return ((barcode.length > 22)
        && "" + barcode[0] + barcode[1] === '01'
        && isSeparator);
}
exports.isBatchBarcode = isBatchBarcode;
// This can safely wrap all barcode inputs
function convertToRegularBarcodeIfBatch(barcode) {
    if (isBatchBarcode(barcode)) {
        var subString = barcode.slice(2, 16);
        // If there are leading 00 digits, remove those
        if (subString[0] === '0' && subString[1] === '0') {
            return subString.substring(2);
        }
        return subString;
    }
    return barcode;
}
exports.convertToRegularBarcodeIfBatch = convertToRegularBarcodeIfBatch;
function getBatchNameFromBarcode(barcode) {
    if (isBatchBarcode(barcode)) {
        return barcode.slice(26);
    }
    return undefined;
}
exports.getBatchNameFromBarcode = getBatchNameFromBarcode;
function getBatchFromBatchNumber(product, batchNumber) {
    var batch = product.batches.find(function (batch) { return batch.batchNumber.toUpperCase() === batchNumber.toUpperCase(); });
    return batch;
}
exports.getBatchFromBatchNumber = getBatchFromBatchNumber;
/**
 * Code-128 type of barcodes support special characters and empty space
 * ref: https://en.wikipedia.org/wiki/Code_128
 * So, only zero-width-space is replaced when cleaning the barcode
 * @param barcode
 */
function cleanBarcode(barcode) {
    return barcode
        .replace(/\u200B/g, '') // Removes zero-width space characters (invisible Unicode character often used in copy-protection)
        .replace(/(\r\n|\n|\r)/gm, '') // Removes all types of line breaks (CRLF on Windows, LF on Unix, CR on old Mac)
        .replace(/[()]/g, '') // Removes parentheses for Socket Mobile scanners that add parentheses around the barcode identifiers
        .trim();
}
exports.cleanBarcode = cleanBarcode;
function ifMatchingBatchNumberExists(product, batchNumber) {
    return product.batches.some(function (batch) { return batch.batchNumber.toUpperCase() === batchNumber.toUpperCase(); });
}
exports.ifMatchingBatchNumberExists = ifMatchingBatchNumberExists;
//# sourceMappingURL=barcode.js.map